import { httpRequest } from "../../http";

import { Employee } from "@models/employee.model";
import { EmployeeSerializer } from "@models/serializers/employeeSerializer";

export class CommandGetEmployees {
  async run(organizationId: number) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/employees/?organization=${organizationId}`;
    try {
      const response = await httpRequest<any>(url);
      return this.deserialize(response);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  deserialize(data: any): Employee[] {
    const serializer = new EmployeeSerializer();
    return serializer.deserializeList(data);
  }
}
